import { pickDarkOrLightIcon, tagTransform } from "lib/table/contentTabTableTransforms.js";
import { dateTransform } from "lib/table/tableTransforms.js";

export const contentTabPushPullCountry = [
	{
		name: "",
		id: "type",
		width: 30,
		fixed: true,
		transform: pickDarkOrLightIcon,
	},
	{
		name: "Title",
		id: "title",
		width: 30,
		fixed: false,
		transform: tagTransform,
	},
	{
		name: "Push/pull",
		id: "pushPull",
		width: 100,
		fixed: true,
	},
	{
		name: "Country",
		id: "location",
		width: 150,
		fixed: true,
	},
	{
		name: "Date",
		id: "postDate",
		width: 100,
		fixed: true,
		transform: dateTransform,
	},
];

export const contentTabBase = [
	{
		name: "",
		id: "type",
		width: 30,
		fixed: true,
		transform: pickDarkOrLightIcon,
	},
	{
		name: "Title",
		id: "title",
		width: 30,
		fixed: false,
		transform: tagTransform,
	},
	{
		name: "Date",
		id: "postDate",
		width: 100,
		fixed: true,
		transform: dateTransform,
	},
];

export const contentTabSource = [
	{
		name: "",
		id: "type",
		width: 30,
		fixed: true,
		transform: pickDarkOrLightIcon,
	},
	{
		name: "Title",
		id: "title",
		width: 30,
		fixed: false,
		transform: tagTransform,
	},
	{
		name: "Source",
		id: "source",
		width: 200,
		fixed: true,
	},
	{
		name: "Date",
		id: "postDate",
		width: 100,
		fixed: true,
		transform: dateTransform,
	},
];
